<template>
    <div class="invite_friends">
        <div class="navbar">
            <div class="left">
                <!-- <span class="material-icons" @click="$router.go(-1)">chevron_left</span> -->
                <svg @click="$router.go(-1)" t="1748487155504" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="21829" width=".6rem" height=".6rem">
                    <path
                        d="M637.5424 231.2192c22.8352 22.3232 24.6272 53.4016 0 80.6912l-191.8464 200.0896 191.8464 200.0896c24.6272 27.2896 22.8352 58.4192 0 80.5888-22.784 22.3232-61.2864 20.8896-82.688 0-21.4016-20.7872-230.5024-240.384-230.5024-240.384-11.4176-11.1104-17.152-25.7024-17.152-40.2944s5.7344-29.184 17.152-40.3968c0 0 209.1008-219.4944 230.5024-240.384s59.904-22.3232 82.688 0z"
                        fill="#ffffff" p-id="21830"></path>
                </svg>
            </div>
            <div class="right">
                <!-- <span class="material-icons" @click="$router.push('/system_messages')">notifications_none</span> -->
                <svg @click="$router.push('/system_messages')" t="1748486708493" class="icon" viewBox="0 0 1024 1024"
                    version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18639" width=".6rem" height=".6rem">
                    <path
                        d="M823.04 727.04L768 672v-213.333333c0-130.986667-69.973333-240.64-192-269.653334v-29.013333c0-35.413333-28.586667-64-64-64s-64 28.586667-64 64v29.013333C325.546667 218.026667 256 327.253333 256 458.666667v213.333333l-55.04 55.04c-26.88 26.88-8.106667 72.96 29.866667 72.96h561.92c38.4 0 57.173333-46.08 30.293333-72.96zM682.666667 714.666667H341.333333v-256c0-105.813333 64.426667-192 170.666667-192s170.666667 86.186667 170.666667 192v256z m-170.666667 213.333333c46.933333 0 85.333333-38.4 85.333333-85.333333h-170.666666a85.333333 85.333333 0 0 0 85.333333 85.333333z"
                        p-id="18640" fill="#ffffff"></path>
                </svg>
            </div>
        </div>
        <div class="container">
            <div class="img">
                <img src="" alt="">
            </div>
        </div>
        <div class="copy">
            {{ $t('user.t40') }}
        </div>
        <div class="promotion">
            <div class="images">
                <div class="back"></div>
                <span class="material-icons  vm md-32">monetization_on</span>
                <span class="material-icons vm  md-34">monetization_on</span>
                <span class="material-icons vm md-36">monetization_on</span>
            </div>
            <div class="content">
                {{ msg }}
            </div>
            <div class="dazzling">
                <span>{{ $t('user.t1') }}</span>
                <span>{{ userInfo.invite_code }}</span>
            </div>
            <div class="btn" @click="copy">
                <i class="material-icons">insert_link</i>
                {{ $t('user.t83') }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            msg: '',
            userInfo: JSON.parse(localStorage.getItem('userInfo'))
        }
    },
    created() {
        this.inviteFriends()
    },
    methods: {
        inviteFriends() {
            this.$http.inviteFriends().then(res => {
                if (res.code == 0) {
                    this.msg = res.invite_msg
                }
            })
        },
        copy() {
            navigator.clipboard.writeText(this.userInfo.invite_code)
            this.$toast.success(this.$t('user.t55'))
        }
    }
}
</script>

<style lang="less" scoped>
.invite_friends {
    .navbar {
        display: flex;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 1.44rem;
        color: #fff;

        .left {
            text-align: center;
            width: 1.44rem;

            .material-icons {}
        }

        .right {
            text-align: center;

            width: 1.44rem;

            .material-icons {}
        }
    }

    .material-icons {}

    .promotion {
        padding: 0.4rem;
        margin: 0 .4rem;
        margin-top: 2rem;
        background-color: #fff;
        // height: 5.3333rem;
        border-radius: .2667rem;

        .images {
            display: flex;
            justify-content: center;
            height: 2.6667rem;
            position: relative;
            align-items: center;
            width: 100%;

            .back {
                // background: linear-gradient(135deg, #DD585CFF 0%, #D44246 100%);
                background-color: #121212 !important;
                color: #fff;
                border-radius: 50%;
                opacity: .3;
                width: 2.6667rem;
                height: 2.6667rem;
                padding: .4rem;
                position: absolute;
                top: 0;
            }

            .material-icons {}

            .vm {
                position: relative;
                z-index: 1;
                color: #fff;
            }

            .md-32 {
                font-size: .64rem;
            }

            .md-34 {
                font-size: .64rem;
            }

            .md-36 {
                font-size: .96rem;
            }
        }

        .content {
            color: #343a40;
            font-weight: 400;
            margin-top: .4267rem;
            font-size: .3733rem;
        }

        .dazzling {
            overflow: hidden;
            text-align: center;
            font-weight: bold;
            font-style: oblique;
            background-image: -webkit-linear-gradient(0deg, #f74fad, #ff568a, #ff8c46, #ffab2d, #ffb700, #ffa900, #ff9b00, #ff8c00, #f74fad);
            -webkit-text-fill-color: transparent;
            -webkit-background-clip: text;
            animation: stream 1s infinite linear;
            background-size: 50% 100%;

            span {
                margin-right: .2133rem;
                font-size: .3733rem;
            }
        }

        .btn {
            color: #fff;
            background-color: #121212;
            margin-top: .64rem;
            padding: .3467rem 0;
            border-radius: .8rem;
            display: flex;
            align-items: center;
            justify-content: center;

            .material-icons {}
        }
    }

    .container {
        min-height: 6.6667rem;
        // background: linear-gradient(135deg, #DD585CFF 0%, #D44246 100%);
        background-color: #121212 !important;
        display: flex;
        justify-content: center;
        padding-top: 1.44rem;

        .img {
            width: 80%;
            height: 5.3333rem;

            img {}
        }
    }

    .copy {
        margin-top: -4rem;
        font-size: .65rem;
        text-align: center;
        color: #fff;
    }
}

::v-deep {
    .van-nav-bar {
        color: #fff;
        // height: 100%;
        // background: linear-gradient(135deg, #a700ff 0%, #00189a 100%);

        .van-nav-bar__content {
            // height: 100%;

            .van-ellipsis {
                overflow: inherit;
            }
        }
    }
}

@keyframes stream {
    0% {
        background-position: 0 0;
    }

    50% {
        background-position: 50% 0;
    }

    100% {
        background-position: 100% 0;
    }
}
</style>